import { TooltipController } from './chunk-BSU4PWFL.js';
import { setAttributeIfEmpty, onPress } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { __decorateClass } from './chunk-VPSTUDLO.js';
import { signal, peek, isWriteSignal, onDispose } from 'maverick.js';
import { defineElement, prop, Component, ComponentController } from 'maverick.js/element';
import { ariaBool } from 'maverick.js/std';

var ARIAKeyShortcuts = class extends ComponentController {
  constructor(instance, _shortcut) {
    super(instance);
    this.jc = _shortcut;
  }
  onAttach(el) {
    const { $props, ariaKeys } = useMedia(), keys = el.getAttribute("aria-keyshortcuts");
    if (keys) {
      ariaKeys[this.jc] = keys;
      {
        onDispose(() => {
          delete ariaKeys[this.jc];
        });
      }
      return;
    }
    const shortcuts = $props.keyShortcuts()[this.jc];
    if (shortcuts)
      el.setAttribute("aria-keyshortcuts", shortcuts);
  }
};

// src/player/ui/buttons/toggle-button.tsx
var toggleButtonProps = {
  disabled: false,
  defaultPressed: false,
  defaultAppearance: false
};
var ToggleButton = class extends Component {
  constructor(instance) {
    super(instance);
    this.u = signal(false);
    new FocusVisibleController(instance);
    new TooltipController(instance);
    if (this.la)
      new ARIAKeyShortcuts(instance, this.la);
  }
  get pressed() {
    return peek(this.u);
  }
  onAttach(el) {
    if (isWriteSignal(this.u)) {
      this.u.set(this.$props.defaultPressed());
    }
    setAttributeIfEmpty(el, "tabindex", "0");
    setAttributeIfEmpty(el, "role", "button");
    const { disabled, defaultAppearance } = this.$props;
    this.setAttributes({
      disabled,
      "default-appearance": defaultAppearance,
      "data-pressed": this.u,
      "aria-pressed": this.cg.bind(this),
      "data-media-button": true
    });
  }
  onConnect(el) {
    onPress(el, this.dg.bind(this));
  }
  cg() {
    return ariaBool(this.u());
  }
  G(event) {
    if (isWriteSignal(this.u)) {
      this.u.set((p) => !p);
    }
  }
  dg(event) {
    const disabled = this.$props.disabled();
    if (disabled) {
      if (disabled)
        event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    this.G(event);
  }
};
ToggleButton.el = defineElement({
  tagName: "media-toggle-button",
  props: toggleButtonProps
});
__decorateClass([
  prop
], ToggleButton.prototype, "pressed", 1);

export { ToggleButton, toggleButtonProps };
